import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import { api } from "../../../../api";
import Cookies from "js-cookie";

const Employees3 = () => {
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [clientForm, setClientForm] = useState({
    name: "",
    status: "",
    Starting: "",
    Ending: "",
  });
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteProjectName, setDeleteProjectName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedDepartmentOptions, setSelectedDepartmentOptions] = useState(
    []
  );

  const filtered = Array.isArray(filteredEmployees)
    ? filteredEmployees.filter(
      (item) =>
        item &&
        item.emp_name &&
        item.emp_name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : [];

  const [selectedMemberOptions, setSelectedMemberOptions] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [employees, setEmployees] = useState([]);

  const toggleModal = () => setModalOpen((prevState) => !prevState);
  const toggleNewEmployee = () =>
    setShowAddClientModal((prevState) => !prevState);

  const toggleAddProjectModal = () =>
    setShowAddProjectModal(!showAddProjectModal);

  const handleProjectChange = (e) => {
    setSelectedProject(e.target.value);
  };

  const filterEmployees = () => {
    if (!searchQuery) {
      setFilteredEmployees(employees);
    } else {
      const filtered = employees.filter((employee) =>
        employee.emp_name && employee.emp_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredEmployees(filtered);
    }
  };

  useEffect(() => {
    filterEmployees();
  }, [searchQuery]);

  const handleDeleteConfirmation = (confirmed, employeeId) => {
    if (confirmed) {
      console.log(`Deleting employee with ID: ${employeeId}`);
      const fetchData = async () => {
        try {
          const response = await api.get(
            `employeesView.php?emp_id=${employeeId}&company_id=${Cookies.get('company_id')}`
          );
          console.log(response.data);
          window.location.reload();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
    // Close the delete confirmation modal
    toggleDeleteConfirmationModal(employeeId);
  };

  const handleAddProject = () => {
    // Handle adding project logic here
    console.log("Selected Project:", selectedProject);
    // You can perform further actions here, like submitting the form or calling an API
    // Reset selected project and close modal
    setSelectedProject("");
    toggleAddProjectModal();
  };

  const handleDepartmentSelectChange = (selectedOptions) => {
    setSelectedDepartmentOptions(selectedOptions);
    setClientForm((prevState) => ({
      ...prevState,
      department: selectedOptions.map((option) => option.value),
    }));
  };

  const handleMemberSelectChange = (selectedOptions) => {
    setSelectedMemberOptions(selectedOptions);
    setClientForm((prevState) => ({
      ...prevState,
      members: selectedOptions.map((option) => option.value),
    }));
  };

  const handleManagerSelectChange = (selectedOption) => {
    setSelectedManager(selectedOption);
  };

  const handleLocationSelectChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
  };

  const toggleViewMoreModal = (employee) => {
    setSelectedEmployee(employee);
  };

  const renderViewMoreModal = () => {
    if (!selectedEmployee) return null;

    return (
      <Modal isOpen={true} toggle={() => toggleViewMoreModal(null)}>
        <ModalHeader toggle={() => toggleViewMoreModal(null)}>
          <h2>Employee Name Details</h2>
        </ModalHeader>
        <ModalBody style={{ color: "black", fontWeight: "bold" }}>
          <div style={{ maxWidth: '400px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <img
                alt="Employee_Image"
                className="rounded-circle"
                src={selectedEmployee && selectedEmployee.profile_image
                  ? (window.location.hostname === 'localhost'
                      ? require(`../../../images/${selectedEmployee.profile_image}`)
                      : `/images/${selectedEmployee.profile_image}`)
                  : '/images/default.png'}
                style={{ height: 100, marginBottom: 10 }}
                onError={e => { e.target.onerror = null; e.target.src = '/images/default.png'; }}
              />
            </div>
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left', width: '45%' }}>Name</td>
                  <td style={{ padding: '8px 0', textAlign: 'left' }}>{selectedEmployee.emp_name}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Contact Number</td>
                  <td style={{ padding: '8px 0', textAlign: 'left' }}>{selectedEmployee.phoneno}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Email Id</td>
                  <td style={{ padding: '8px 0', textAlign: 'left' }}>{selectedEmployee.email}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Date Of Birth</td>
                  <td style={{ padding: '8px 0', textAlign: 'left' }}>{selectedEmployee.dob}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Role</td>
                  <td style={{ padding: '8px 0', textAlign: 'left' }}>{selectedEmployee.role}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Date Of Joining</td>
                  <td style={{ padding: '8px 0', textAlign: 'left' }}>{selectedEmployee.doj}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Salary</td>
                  <td style={{ padding: '8px 0', textAlign: 'left' }}>{selectedEmployee.salary}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Address</td>
                  <td style={{ padding: '8px 0', textAlign: 'left' }}>{selectedEmployee.address}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  const [empdetails, setempdetails] = useState();
  const [loading, setLoading] = useState(true);
  const [emp, setemp] = useState();
  const [deleteConfirmationEmployeeId, setDeleteConfirmationEmployeeId] = useState(null);
  const [role, setrole] = useState();
  const [department, setdepartment] = useState();
  const [showAddHobbyModal, setShowAddHobbyModal] = useState(false);
  const [hobbyInput, setHobbyInput] = useState("");
  const [addedHobbies, setAddedHobbies] = useState({
    emails: []  // empty array to hold the list of emails
  });
  const [showEmailClientModal, setShowEmailClientModal] = useState(false);
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteRole, setInviteRole] = useState("");
  const [inviteDepartment, setInviteDepartment] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [inviteSuccess, setInviteSuccess] = useState("");
  const [inviteError, setInviteError] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`employeesView.php?company_id=${Cookies.get('company_id')}`);
      setEmployees(response.data);
      setFilteredEmployees(response.data);
      setLoading(false);
      // console.log(empdetails)
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setemp((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    console.log(emp);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setemp((prevState) => ({
      ...prevState,
      files: file,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("emp_name", emp.emp_name);
    formDataToSend.append("email", emp.email);
    formDataToSend.append("phoneno", emp.phoneno);
    formDataToSend.append("dob", emp.dob);
    formDataToSend.append("doj", emp.doj);
    formDataToSend.append("role", emp.role);
    formDataToSend.append("salary", emp.salary);
    formDataToSend.append("department", emp.department);
    formDataToSend.append("address", emp.address);
    formDataToSend.append("files", emp.files);
    formDataToSend.append("company_id", Cookies.get('company_id'));
    formDataToSend.append("password", emp.password);

    try {
      const response = await api.post("addEmployee.php", formDataToSend);
      console.log("Data sent successfully:", response.data);
      
      // Show success notification
      setSuccessMessage('Employee added successfully!');
      setShowSuccessNotification(true);
      // Do NOT close modal or reload here
      // toggleNewEmployee();
      // setemp({});
      // setShowPassword(false);
      // fetchData();
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const toggleDropdown = (id) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleDropdownItemClick = (action, employeeId, employeeName) => {
    if (action === "Delete") {
      // Open delete confirmation modal
      toggleDeleteConfirmationModal(employeeId);
    } else {
      console.log(`Clicked ${action}`);
    }
  };

  const toggleDeleteConfirmationModal = (employeeId) => {
    setDeleteConfirmationEmployeeId(
      employeeId === deleteConfirmationEmployeeId ? null : employeeId
    );
  };
  const fetchRoleData = async () => {
    try {
      const response = await api.get("addRole.php?company_id=" + Cookies.get('company_id'));
      setrole(response.data);
      const response2 = await api.get("department.php?company_id=" + Cookies.get('company_id'));
      setdepartment(response2.data);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchRoleData();
  }, []);



  const toggleNewEmail = () => setShowEmailClientModal((prevState) => !prevState);

  const toggleAddHobbyModal = () => {
    setShowAddHobbyModal(!showAddHobbyModal);
  };

  const handleHobbyInputChange = (e) => {
    setHobbyInput(e.target.value);
  };

  const handleAddHobby = () => {

    if (isValidEmail(hobbyInput)) {
      if (!addedHobbies.emails.some(email => email.toLowerCase() === hobbyInput.toLowerCase())) {
        setAddedHobbies(prevState => ({
          emails: [...prevState.emails, hobbyInput]
        }));
        console.log(addedHobbies);
      } else {
        alert("This email is already added.");
      }
      setHobbyInput("");
    } else {
      alert("Please enter a valid email address.");
    }

  };


  const handleCancel = () => {
    setHobbyInput(""); // Clear the input
    toggleAddHobbyModal(); // Close the modal
  };

  const isValidEmail = (email) => {
    // Regular expression to validate email addresses
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };


  const handleRemoveHobby = (indexToRemove) => {
    setAddedHobbies((prevHobbies) => ({
      emails: prevHobbies.emails.filter((_, index) => index !== indexToRemove)
    }));
  };


  // const EmailSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     let response = await api.post("materialMail.php", addedHobbies, {
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     });
  //     console.log(response.data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const EmailSubmit = (e) => {
    // e.preventDefault();
    api.post(`inviteEmp.php`, addedHobbies, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      console.log(response.data);
    }).catch((error) => {
      console.log(error);
    })
  }

  // Fetch roles for invite modal
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await api.get("addRole.php?company_id=" + Cookies.get('company_id'));
        if (Array.isArray(response.data)) {
          setRoleOptions(response.data.map(r => r.role_name));
        }
      } catch (error) {
        console.error("Error fetching roles for invite:", error);
      }
    };
    fetchRoles();
  }, []);

  // Fetch departments for invite modal if needed
  useEffect(() => {
    if (inviteRole === "Site Manager" || inviteRole === "Engineer") {
      const fetchDepartments = async () => {
        try {
          const response = await api.get("department.php");
          if (Array.isArray(response.data)) {
            setDepartmentOptions(response.data.map(d => ({ value: d.d_id, label: d.dept_name })));
          }
        } catch (error) {
          console.error("Error fetching departments for invite:", error);
        }
      };
      fetchDepartments();
    }
  }, [inviteRole]);

  // Get company_id from cookie or context (adjust as needed)
  const company_id = (document.cookie.match(/company_id=([^;]+)/) || [])[1] || "";

  // Invite Submit Handler
  const handleInviteSubmit = async () => {
    setInviteLoading(true);
    setInviteSuccess("");
    setInviteError("");
    try {
      const payload = {
        email: inviteEmail,
        role: inviteRole,
        company_id,
        department: (inviteRole === "Site Manager" || inviteRole === "Engineer") ? inviteDepartment : null
      };
      const response = await api.post("inviteEmp.php", payload);
      if (response.data && response.data.success) {
        setInviteSuccess("Invite sent successfully!");
        setInviteEmail("");
        setInviteRole("");
        setInviteDepartment("");
        window.location.reload();
      } else {
        setInviteError(response.data.error || "Failed to send invite.");
      }
    } catch (error) {
      setInviteError("Error sending invite.");
    }
    setInviteLoading(false);
  };

  // Invite Modal UI
  const renderInviteModal = () => (
    <Modal isOpen={showEmailClientModal} toggle={toggleNewEmail}>
      <ModalHeader toggle={toggleNewEmail}>Invite Employee</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="inviteEmail">Email</Label>
            <Input
              type="email"
              id="inviteEmail"
              value={inviteEmail}
              onChange={e => setInviteEmail(e.target.value)}
              placeholder="Enter employee email"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="inviteRole">Role</Label>
            <Input
              type="select"
              id="inviteRole"
              value={inviteRole}
              onChange={e => setInviteRole(e.target.value)}
              required
            >
              <option value="">Select Role</option>
              {roleOptions.map(role => (
                <option key={role} value={role}>{role}</option>
              ))}
            </Input>
          </FormGroup>
          {(inviteRole === "Site Manager" || inviteRole === "Engineer") && (
            <FormGroup>
              <Label for="inviteDepartment">Department</Label>
              <Input
                type="select"
                id="inviteDepartment"
                value={inviteDepartment}
                onChange={e => setInviteDepartment(e.target.value)}
                required
              >
                <option value="">Select Department</option>
                {departmentOptions.map(dept => (
                  <option key={dept.value} value={dept.value}>{dept.label}</option>
                ))}
              </Input>
            </FormGroup>
          )}
          {inviteSuccess && <div className="text-success mt-2">{inviteSuccess}</div>}
          {inviteError && <div className="text-danger mt-2">{inviteError}</div>}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleInviteSubmit} disabled={inviteLoading}>
          {inviteLoading ? "Sending..." : "Send Invite"}
        </Button>
        <Button color="secondary" onClick={toggleNewEmail}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );

  // Helper function to get profile image path
  function getProfileImage(profile_image) {
    if (profile_image) {
      return window.location.hostname === "localhost"
        ? require(`../../../images/${profile_image}`)
        : `/images/${profile_image}`;
    }
    return window.location.hostname === "localhost"
      ? require(`../../../images/default-profile.png`)
      : "/images/default-profile.png";
  }

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          {/* MOBILE & TABLET: Heading, then search, then buttons, all centered and stacked */}
          <Row className="d-flex d-lg-none flex-column align-items-center mb-6">
            <Col xs="12" className="text-center mb-2">
              <h1 className="text-black">Employees List</h1>
            </Col>
            <Col xs="12" className="mb-2 d-flex justify-content-center">
              <Form className="navbar-search w-100" style={{ maxWidth: '300px' }}>
                <FormGroup className="mb-0 w-100">
                  <InputGroup className="input-group-alternative align-items-center h-[40px]">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText className="border-right-0 h-[38px]">
                        <i className="fas fa-search text-black" />
                        <Input
                          placeholder="Search Employee"
                          type="text"
                          className="border-left-0 ml-2 h-[38px]"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Form>
            </Col>
            <Col xs="12" className="d-flex justify-content-center gap-2">
              <Button onClick={toggleNewEmployee} style={{ backgroundColor: '#E08681', borderColor: '#E08681', color: 'black' }}>Add Employee</Button>
              <Button onClick={toggleNewEmail} style={{ backgroundColor: '#E08681', borderColor: '#E08681', color: 'black' }}>Invite</Button>
            </Col>
          </Row>

          {/* LAPTOP & DESKTOP: Keep existing layout */}
          <Row className="mb-5 d-none d-lg-flex">
            <Col className="order-xl-2 mb-5 mb-xl-0 text-left">
              <h1 className="text-black">Employees List</h1>
            </Col>
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex">
              <Form className="navbar-search px-2 w-full" style={{ maxWidth: '300px' }}>
                <FormGroup className="mb-0 w-full">
                  <InputGroup className="input-group-alternative align-items-center h-[40px]">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText className="border-right-0 h-[38px]">
                        <i className="fas fa-search text-black" />
                        <Input
                          placeholder="Search Employee"
                          type="text"
                          className="border-left-0 ml-2 h-[38px]"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Form>
              <Button onClick={toggleNewEmployee} style={{ backgroundColor: '#E08681', borderColor: '#E08681', color: 'black' }}>Add Employee</Button>
              <Button onClick={toggleNewEmail} style={{ backgroundColor: '#E08681', borderColor: '#E08681', color: 'black' }}>Invite</Button>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row>
  {filtered &&
    filtered.length > 0 &&
    filtered.map((employee) => (
      <Modal
        key={employee.emp_id}
        isOpen={deleteConfirmationEmployeeId === employee.emp_id}
        toggle={() => toggleDeleteConfirmationModal(employee.emp_id)}
      >
        <ModalHeader
          toggle={() => toggleDeleteConfirmationModal(employee.emp_id)}
        >
          Confirm Delete
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete {employee.emp_name}?
          <div className="mt-3 text-right">
            <form>
              <Button
                color="danger"
                onClick={() =>
                  handleDeleteConfirmation(true, employee.emp_id)
                }
              >{`Yes, delete ${employee.emp_name}`}</Button>{" "}
            </form>
            <Button
              color="secondary"
              onClick={() =>
                handleDeleteConfirmation(false, employee.emp_id)
              }
            >
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    ))}

            {filtered && filtered.length > 0 ? (
              filtered.map((employee) => (
                <Col xs="12" md="6" lg="4" xl="3" key={employee.emp_id}>
                  <Card
                    className="card-profile mb-5"
                    style={{
                      position: 'relative', // <-- important!
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                      backgroundColor: '#fff',
                      borderRadius: '15px'
                    }}
                  >
                    {/* Top-right dropdown: direct child of Card */}
                    <div
                      className="mt-5 mt-md-3"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "16px",
                        zIndex: 2,
                      }}
                    >
                      <Dropdown
                        isOpen={dropdownOpen[employee.emp_id]}
                        toggle={() => toggleDropdown(employee.emp_id)}
                        direction="left"
                      >
                        <DropdownToggle
                          tag="span"
                          data-toggle="dropdown"
                          aria-expanded={dropdownOpen[employee.emp_id]}
                          style={{
                            cursor: "pointer",
                            background: "none",
                            border: "none",
                            boxShadow: "none",
                            padding: 0,
                          }}
                        >
                          <i className="fas fa-ellipsis-v" style={{ fontSize: "20px", color: "#888" }}></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <Link
                             to={`/hr-admin/hr-management/edit-employee/${employee.emp_id}`}
                            style={{ color: "Black" }}
                          >
                            <DropdownItem
                              onClick={() => console.log("Edit clicked")}
                            >
                              Edit
                            </DropdownItem>
                          </Link>
                          <DropdownItem
                            onClick={() =>
                              handleDropdownItemClick(
                                "Delete",
                                employee.emp_id,
                                employee.emp_name
                              )
                            }
                          >
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>

                    {/* Card content */}
                    <Row className="justify-content-center">
                      <Col className="order-lg-2" lg="3">
                        <div className="card-profile-image">
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <img
                              alt="..."
                              className="rounded-circle"
                              src={getProfileImage(employee && employee.profile_image)}
                              style={{ height: 100, width: 100 }}
                              onError={e => {
                                e.target.onerror = null;
                                e.target.src = getProfileImage();
                              }}
                            />
                          </a>
                        </div>
                      </Col>
                    </Row>
                    <CardBody className="pt-0 pt-md-5 mt-5 md:mt-3">
                      <div className="text-center mt-3 mt-md-2 mt-lg-1">
                        <h3 className="mt-3 mt-md-2 mt-lg-1">{employee.emp_name}</h3>
                        <div className="h3 font-weight-600">
                          <span
                            className="p-2 badge badge-secondary"
                            style={{ backgroundColor: "#000", color: "#fff" }}
                          >
                            {employee.role}
                          </span>
                        </div>
                        <div className="h5 mt-4">{employee.phoneno}</div>
                        <hr className="my-4" />
                        <Button
                          // color="primary"
                          href="#pablo"
                          onClick={() => toggleViewMoreModal(employee)}
                          style={{ backgroundColor: '#E08681', borderColor: '#E08681', color: 'black' }}
                        >
                          View More
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No details available, Project not yet started
                </td>
              </tr>
            )}
          </Row>
        </Container>
      </div>
      <Modal isOpen={showAddClientModal} toggle={toggleNewEmployee}>
        <ModalHeader toggle={toggleNewEmployee}>
          <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
            New Employee
          </h2>
        </ModalHeader>
        <ModalBody>
          {showSuccessNotification && (
            <div style={{
              position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
              justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
            }}>
              <div style={{
                backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
              }}>
                <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
                <Button
                  style={{
                    backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                    padding: '10px 25px', borderRadius: '25px'
                  }}
                  onClick={() => {
                    setShowSuccessNotification(false);
                    toggleNewEmployee();
                    setemp({});
                    setShowPassword(false);
                    fetchData();
                  }}
                >OK</Button>
              </div>
            </div>
          )}
          <Form onSubmit={handleFormSubmit}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">
                    Employee Name *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-name"
                    type="text"
                    name="emp_name"
                    onChange={handleInputChange}
                    placeholder="Enter Employee Name"
                    pattern="^[a-zA-Z ]+$"
                    title="Enter letters only"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-number">
                    Contact Number *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-number"
                    type="text"
                    name="phoneno"
                    pattern="^\d{10}$"
                    title="Enter 10 digits only"
                    placeholder="Enter Contact Number"
                    required
                    onChange={handleInputChange}
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-email">
                    Email Id *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-mail"
                    type="email"
                    name="email"
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                    title="Enter valid email address"
                    onChange={handleInputChange}
                    placeholder="Enter Email Address"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-birthday"
                  >
                    Date of Birth *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-birthday"
                    type="date"
                    name="dob"
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-manager">
                    Select Role *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-manager"
                    type="select"
                    name="role"
                    onChange={handleInputChange}
                  >
                    <option value="">Select Role</option>
                    {role &&
                      Array.isArray(role) &&
                      role.map((option) => (
                        <option key={option.role_name} value={option.role_name}>
                          {option.role_name}
                        </option>
                      ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-manager">
                    Select Department *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-manager"
                    type="select"
                    name="department"
                    onChange={handleInputChange}
                  >
                    <option value="">Select Department</option>
                    {department &&
                      Array.isArray(department) &&
                      department.map((option) => (
                        <option key={option.d_id} value={option.d_id}>
                          {option.dept_name}
                        </option>
                      ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-joining">
                    Date of Joining *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-joining"
                    type="date"
                    name="doj"
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-salary">
                    Salary *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-salary"
                    type="text"
                    name="salary"
                    // pattern="^\d"
                    title="Enter numbers only"
                    onChange={handleInputChange}
                    placeholder="Enter Salary"
                    required
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-file">
                    Upload Image *
                  </label>
                  <Input
                    type="file"
                    className="form-control"
                    id="input-file"
                    accept="image/*"
                    name="files"
                    onChange={handleFileChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-password">
                    Password *
                  </label>
                  <InputGroup className="input-group-alternative">
                    <Input
                      className="form-control-alternative"
                      id="input-password"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      onChange={handleInputChange}
                      placeholder="Enter Password"
                      required
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>
                        <i 
                          className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                          style={{ cursor: 'pointer', color: '#d86f89' }}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-location"
                  >
                    Address *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-location"
                    type="text"
                    name="address"
                    onChange={handleInputChange}
                    placeholder="Location"
                    required
                  />
                </FormGroup>
              </Col>
              
            </Row>
            <Row>
              <Col lg="12" style={{ textAlign: "center" }}>
                <Button style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} type="submit">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>




      {renderInviteModal()}


      {renderViewMoreModal()}
    </>
  );
};

export default Employees3;
